import { GEOFENCE_ALERT_MODES, MAP_DATA_SOURCE } from '@constants/map';

// Creates inverted polygon for driving maps: shows restricted areas in red by using
// a world-wide polygon with the geofence as a hole
export function processGeofenceData(geoJSON, alertMode) {
	const features = geoJSON.features.filter((geofence) => geofence.properties.alertMode === alertMode.name);
	const lastFeature = features.length > 0 ? features[features.length - 1] : null;
	
	if (!lastFeature) {
		return {
			features: [],
			type: 'FeatureCollection'
		};
	}

	// World bounds covering the entire map
	const worldBounds = [
		[-180, -85], [-180, 85], [180, 85], [180, -85], [-180, -85]
	];
	
	// Create polygon with world as outer ring and geofence as inner ring (hole)
	// This makes everything red except the safe geofence area
	const invertedFeature = {
		type: 'Feature',
		geometry: {
			type: 'Polygon',
			coordinates: [
				worldBounds,                              // Outer ring: entire world
				lastFeature.geometry.coordinates[0]       // Inner ring: geofence (creates hole)
			]
		},
		properties: {
			alertMode: alertMode.name,
			inverted: true
		}
	};
	
	return {
		features: [invertedFeature],
		type: 'FeatureCollection'
	};
}

export function mapGeofenceConfig({ map, geoJSON }) {
	addGeofenceSource({ map, geoJSON, alertMode: GEOFENCE_ALERT_MODES.safe_zone });
}

export function mapGeofenceConfigForDriving({ map, geoJSON }) {
	addGeofenceSourceForDriving({ map, geoJSON, alertMode: GEOFENCE_ALERT_MODES.safe_zone });
}

function addGeofenceSource({ map, geoJSON, alertMode }) {
	const features = geoJSON.features.filter((geofence) => geofence.properties.alertMode === alertMode.name);

	const data = {
		features: features,
		type: 'FeatureCollection'
	};

	map.addSource(`${MAP_DATA_SOURCE.geofences}-${alertMode.name}`, {
		type: 'geojson',
		data: data
	});

	map.addLayer({
		id: `${MAP_DATA_SOURCE.geofences}-${alertMode.name}`,
		type: 'fill',
		source: `${MAP_DATA_SOURCE.geofences}-${alertMode.name}`,
		layout: {},
		paint: {
			'fill-color': alertMode.color,
			'fill-opacity': 0.5
		}
	});
}

function addGeofenceSourceForDriving({ map, geoJSON, alertMode }) {
	const data = processGeofenceData(geoJSON, alertMode);

	map.addSource(`${MAP_DATA_SOURCE.geofences}-${alertMode.name}`, {
		type: 'geojson',
		data: data
	});

	map.addLayer({
		id: `${MAP_DATA_SOURCE.geofences}-${alertMode.name}`,
		type: 'fill',
		source: `${MAP_DATA_SOURCE.geofences}-${alertMode.name}`,
		layout: {},
		paint: {
			'fill-color': '#FF6B6B',
			'fill-opacity': 0.3
		}
	});
}
